import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "../common-components";
import { WawiApiBelegeModule } from './belege/belege.module';
import { WawiApiNotesModule } from "./notes/notes.module";
import { WawiApiAddressesModule } from "./addresses/addresses.module";
import { WawiApiInvoiceModule } from "./invoices/invoice.module";

@NgModule({
  imports: [CommonComponentsModule, WawiApiInvoiceModule, WawiApiAddressesModule, WawiApiBelegeModule, WawiApiNotesModule],
  declarations: [],
  exports: [WawiApiAddressesModule, WawiApiInvoiceModule, WawiApiBelegeModule, WawiApiNotesModule]
})
export class WaWiApiModule {}
